import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ebc84c70")

_pushScopeId("data-v-ebc84c70")
const _hoisted_1 = { class: "p-d-flex p-flex-row kn-flex kn-overflow" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_WorkspaceFederationDefinitionMetafieldsList = _resolveComponent("WorkspaceFederationDefinitionMetafieldsList")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.federationDefinition.associationsEditor')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("div", {
        class: "p-d-flex kn-flex",
        style: _ctx.workspaceFederationDatasetListDescriptor.styles.metaContainer
      }, [
        _createVNode("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasets, (dataset) => {
            return (_openBlock(), _createBlock(_component_WorkspaceFederationDefinitionMetafieldsList, {
              style: _ctx.workspaceFederationDatasetListDescriptor.styles.metaList,
              class: "metafield-select-list p-mx-2 p-mb-2",
              key: dataset.id,
              propDataset: dataset,
              selectedMetafields: _ctx.selectedMetafields,
              resetSelectedMetafield: _ctx.resetSelectedMetafield
            }, null, 8, ["style", "propDataset", "selectedMetafields", "resetSelectedMetafield"]))
          }), 128))
        ])
      ], 4)
    ]),
    _: 1
  }))
})